module.exports = __webpack_public_path__ + "img/requests-img.248cb76b.svg";